import React, { Component, useReducer } from 'react';
import {Collapse, OverviewToggler,OverviewBrand,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {Triangle} from 'react-loader-spinner';

  class ClientWorkouts extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
          workouts: [],
          current_render: 'workouts',
          workout: {},
          loading: true
      };

      this.HandleChange = (e) => {
        this.setState({[e.target.name]: e.target.value});
      };

      this.ViewWorkout = (workout) => {
        this.setState({
          current_render: 'workout',
          workout: workout
        })
      }

      this.ViewWorkouts = () => {
        this.setState({current_render: 'workouts'})
      }

      this.SelectRender = () => {
        var current_render = this.state.current_render

        if (current_render == 'workouts'){
          var workouts = this.state.workouts

          var workouts_map = workouts.map((item, index) => {
            return<Row style={{minHeight: '100px', width: '200px', margin: '5px', background: '#FFFFFF', boxShadow: '0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12)'}}>
              <Col style={{textAlign: 'left'}}>
                <a onClick={() => this.ViewWorkout(item)} style={{color: 'inherit'}}>
                    <img src={Backend_Url + 'media/' + item.image} style={{marginTop: '10px', width: '100%', borderTopLeftRadius: '20px', borderTopRightRadius: '20px'}}/>
                    <h5 style={{fontSize: '14px', color: '#666', marginTop: '10px'}}>
                        {item.name}
                    </h5>
                    <h5 style={{marginTop: '10px', fontSize: '16px', height: '18px', lineHeight: '18px', color: '#333', fontWeight: '700'}}>
                        
                    </h5>
                    <h6 style={{marginTop: '10px', marginBottom: '10px', color: '#333'}}>
                        {item.goal}
                    </h6>
                </a>
              </Col>
            </Row>
          })

          return<Row>
            {workouts_map}
          </Row>

        }else if(current_render == 'workout'){
          var workout = this.state.workout

          return<div>
            <br/>
              <Button onClick={this.ViewWorkouts} style={{backgroundColor: 'inherit', color: 'inherit', border: 'none'}}>
                {'<<<'} Back
              </Button>
            <br/>
            <div style={{marginTop: '30px'}}>
              <Row>
                <Col>
                  <img src={Backend_Url + 'media/' + workout.image} style={{width: '100%'}}/>
                </Col>
                <Col>
                  <h5 style={{textAlign: 'center', marginTop: '10px', fontSize: '16px', height: '18px', lineHeight: '18px', color: '#666', fontWeight: '700'}}>
                    {workout.name}
                  </h5>
                  <h4 style={{textAlign: 'center', marginTop: '40px', fontSize: '20px', height: '18px', lineHeight: '18px', color: '#333', fontWeight: '700'}}>
                    {workout.goal}
                  </h4>
                  <p style={{marginTop: '50px', textAlign: 'left'}}>
                    {workout.description}
                  </p>
                </Col>
              </Row>
            </div>
          </div>
        }else{
          return<div>
            <br/>
            <Row>
              <Col>
                <h5 style={{marginTop: '60px', textAlign: 'center', marginBottom: '400px'}}>
                  Something went wrong, please try opening this section again.
                </h5>
              </Col>
            </Row>
          </div>
        }
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
      
      const { cookies } = this.props;
      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))

      axios.post(Backend_Url + 'getClientWorkouts', data)
      .then((res) => {
          let result = res.data
            this.setState({workouts: result, loading: false})
      }).catch((error) => {
          console.log(error)
      })
    }




    render() {
      if (this.state.loading == true){
        return (
          <Row>
            <Helmet>
              <title>Workouts - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <Container style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
                <br/>
                <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                  ONFIT
                </h1>
                <br/><br/>
                <Triangle
                    color="#1FACED"
                    height={130}
                    width={130}
                />
                <h3 style={{marginTop: '50px', color: '#1FACED'}}>
                  Loading...
                </h3>
                <h6 style={{marginTop: '50px'}}>
                    Taking too long to load? Check your internet connection and reload the page.
                </h6>
                <br/><br/>
              </Container>
            </div>
          </Row>
        )
      }

        var workouts = this.state.workouts

        if(workouts.length == 0 && this.state.loading == false){
            return (
                <Row>
                    <Helmet>
                      <title>Workouts - ONFIT</title>
                      {/* <meta name="description" content="" /> */}
                    </Helmet>
                    <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
                      <br/>
                      <h4 style={{}}>
                        Your Workouts
                      </h4>
                      <br/><br/>
                      <Container>
                        <br/>
                        No workoutplans have been set by any trainer for you yet. You'll receive a notification once a trainer sets one for you.
                      </Container>
                    </div>
                </Row> 
            )
        }

      return (
        <Row>
            <Helmet>
              <title>Workouts - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Your Workouts
              </h4>
              <br/><br/>
              <Container>
                <this.SelectRender/>
              </Container>
              <br/><br/><br/>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(ClientWorkouts);